import React from "react";
import { Button, Icon, Input, Table } from "antd/lib/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Highlighter from "react-highlight-words";
import { getFirebaseData } from "../../../redux/actions/network";
import {
  deleteStudentGroup,
  fixStudentIds
} from "../../../redux/actions/groups";

import { selectStudentsByGroupKey } from "../../../redux/selectors/groups";
import { selectAllEntities } from "../../../redux/selectors/global";

class Actividades extends React.Component {
  state = {
    searchText: ""
  };

  componentDidMount() {
    const { getFirebaseData } = this.props;
    getFirebaseData();
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] &&
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => {
      return (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={(text && text.toString()) || ""}
        />
      );
    }
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const secondExpandedRowRender = y => {
      const secondRowNestedData = Object.keys(this.props.respuestas).filter(
        id => id === y
      );

      const Rcolumns = [
        {
          title: "Numero Pregunta",
          dataIndex: "numeroPregunta",
          key: "numeroPregunta"
        },
        {
          title: "Respuesta",
          dataIndex: "respuesta",
          key: "respuesta"
        },
        {
          title: "Respuesta Correcta",
          dataIndex: "respuestaCorrecta",
          key: "respuesta"
        }
      ];

      console.log("secondRowNestedData", secondRowNestedData);
      return (
        <Table
          columns={Rcolumns}
          dataSource={secondRowNestedData[0].respuestas}
        />
      );
    };

    const expandedRowRender = x => {
      const groupData = [];
      const rowNestedData = this.props.respuestas.map(respuesta => {
        if (x.tipoActividad === "transfer" && !!respuesta.groupKey) {
          groupData.push({ ...respuesta, tipoActividad: "transfer" });
        } else if (
          respuesta.nivel === x.nivel &&
          respuesta.tipoActividad === x.tipoActividad
        ) {
          groupData.push(respuesta);
        }
      });
      const columns = [
        {
          title: "Nombre de grupo",
          dataIndex: "nombreGrupo",
          key: "nombreGrupo"
        },
        {
          title: "Nivel",
          key: "nivel",
          dataIndex: "nivel"
        },
        {
          title: "Estudiante que envió respuesta",
          dataIndex: "submitUserNombre",
          key: "submitUserNombre"
        },
        {
          title: "Tipo de Actividad",
          key: "tipoActividad",
          dataIndex: "tipoActividad"
        },

        {
          title: "Colegio",
          dataIndex: "submitUserColegio",
          key: "submitUserColegio",
          ...this.getColumnSearchProps("submitUserColegio")
        }
      ];

      return (
        <Table
          columns={columns}
          dataSource={groupData}
          expandedRowRender={secondExpandedRowRender}
        />
      );
    };
    const columns = [
      {
        title: "Etapa",
        dataIndex: "etapa",
        key: "etapa",
        render: x => {
          return <div key={x}>{x + 1}</div>;
        }
      },
      {
        title: "Nivel",
        dataIndex: "nivel",
        key: "nivel"
      },

      {
        title: "Nombre Etapa",
        dataIndex: "nombreEtapa",
        key: "nombreEtapa",
        width: "20%"
      },

      {
        title: "Tipo de Actividad",
        dataIndex: "tipoActividad",
        key: "tipoActividad",
        width: "20%"
      },
      {
        title: "Titulo de Actividad",
        dataIndex: "tituloActividad",
        key: "tituloActividad",
        width: "20%"
      }
    ];
    const { loading, preguntas } = this.props;
    return (
      <React.Fragment>
        <Table
          columns={columns}
          rowKey={pregunta => pregunta.key}
          dataSource={preguntas}
          expandedRowRender={expandedRowRender}
          loading={loading}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getFirebaseData, deleteStudentGroup, fixStudentIds },
    dispatch
  );

const mapStateToProps = state => {
  const selectStudents = groupKey => selectStudentsByGroupKey(state, groupKey);
  const users = selectAllEntities(state, "users");
  const groups = selectAllEntities(state, "groups");
  const preguntas = selectAllEntities(state, "preguntas");
  const respuestas = selectAllEntities(state, "respuestas");

  return {
    groups,
    selectStudents,
    respuestas,
    preguntas,
    users
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Actividades);
